module.exports = __webpack_public_path__ + "img/17_nakamichi_instructions.fc29e7df.jpg";